import "../../sass/main.scss";
import {bootPage} from "../app/boot-page";
import {popupContent} from "../components/popup-content";
import {ajaxCreateBookingPeriod, createBooking, togglePeriodFiltering} from "../helpers/booking";
import {dateRangePickerWeek, togglePeriod} from "../helpers/date-range-picker";
import {getSingleParameter, setSingleParameter} from "../helpers/helpers";

class BookingLandingPage {
    selector = {
        activeSelector: $('[data-period-time].active'),
        bookingForm: 'form[data-create-ticket]',
    }

    constructor() {
        this.eventHandlers();
        new popupContent('wl_ajax_booking_popup', 'booker-config');
        setSingleParameter('start', this.selector.activeSelector.data('start'));
        setSingleParameter('end', this.selector.activeSelector.data('end'));
        ajaxCreateBookingPeriod(getSingleParameter('start'), getSingleParameter('end'));
        dateRangePickerWeek();
    }

    eventHandlers() {
        $(document.body).on("submit", this.selector.bookingForm, createBooking.bind(this));
        $(document.body).on('click', '[data-period-time]', togglePeriodFiltering.bind(this));
        $(document.body).on('change', '#toggle-period', togglePeriod.bind(this));
        $(document.body).on('change', '[data-create-booking-duration]', (event) => {
            ajaxCreateBookingPeriod(getSingleParameter('start'), getSingleParameter('end'), Number(event.currentTarget.value));
        });
    }
}

bootPage(() => {
    new BookingLandingPage();
});
